import { createContext } from 'react';

const TeamContext = createContext();

export default TeamContext;